
import { useEffect } from 'react'
import Select from 'react-select'
import { WTPLocationMasterDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const WTPLocationMasterDDL = (props) => {
    const { LocationName, setLocationName, WardName, IsPost } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_WardID: WardName.ID,
            M_UserID: UserID,
            token: token,
        }
        // if (UnitType.ID) {
        dispatch(WTPLocationMasterDDLAPI({ data }))
        // }
    }, [IsPost,WardName.ID])

    const { WTPLocationMasterData } = useSelector(state => state.WTPLocationMasterDDL)

    useEffect(() => {
        handleWTPLocationMasterDataDDL()
    }, [WTPLocationMasterData])

    const handleWTPLocationMasterDataDDL = () => {
        // console.log(DeptDDLDataa)
        if (WTPLocationMasterData && WTPLocationMasterData.table && WTPLocationMasterData.table.length > 0) {
            let list = WTPLocationMasterData.table.map((item, index) => ({
                value: item.m_wtP_LocationID,
                label: item.locationName,
            }))

            // setEmployeeDDL({
            //     DDL: list,
            //     ID: Flag === 'Update' ? rowData.m_EmployeeID : 0,
            //     Label: Flag === 'Update' ? rowData.employeeName : "Select...",
            // })
            setLocationName({ ...LocationName, DDL: list })
        }
        else {
            setLocationName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }
    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Location Name</b></label>
            <Select
                // isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                isSearchable
                isDisabled={WardName.ID == 0 }
                maxMenuHeight={150}
                value={{ value: LocationName.ID, label: LocationName.Label }}
                onChange={(e) => {
                    e ?
                        setLocationName({ ...LocationName, ID: e.value, Label: e.label })
                        :
                        setLocationName({ ...LocationName, ID: 0, Label: "Select..." })

                }}
                options={LocationName.DDL}
            />
        </div>
    )
}